import FlexBox from './FlexBox';

export * from './FlexBox';

export default FlexBox;
